module.exports = __webpack_public_path__ + "static/media/img_1_1685965544922.95e2bb83.jpg";